/**
 * Stable refs for {@link AdminServerList} / freight data tables (`lengthMenu`, default sort).
 * Inline arrays in hook deps cause extra remounts/fetches.
 */
export const FREIGHT_DT_DEFAULT_ORDER = Object.freeze([[2, "desc"]]);

export const FREIGHT_DT_LENGTH_MENU_25 = Object.freeze([
  [25, 50, 100],
  [25, 50, 100]
]);
